export default __webpack_public_path__ + "static/media/219.0feef048.jpg";